import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { chatListAtom } from '../states/chat-list';
import { ChatListAtom } from '../typings';
import { filterCompleteConditions } from '../components/chat-list-section/custom-field-filter/utils';

export function useHasAnyFilters(): boolean {
  const state = useAtomValue(chatListAtom) as ChatListAtom;
  const { tags, assignedUserId, waba, conversationView, customFieldConditions } = state;

  return useMemo(() => {
    const hasTags = (tags ?? []).length > 0;
    const hasAssignee = assignedUserId && assignedUserId !== 'all' && assignedUserId !== 'null';
    const hasWaba = (waba ?? []).length > 0;
    const hasViewFilter = conversationView === 'groups';
    const hasCustomFieldConditions = filterCompleteConditions(customFieldConditions ?? []).length > 0;

    return Boolean(hasTags || hasAssignee || hasWaba || hasViewFilter || hasCustomFieldConditions);
  }, [tags, assignedUserId, waba, conversationView, customFieldConditions]);
}
